import { TaxReturnCellChangedHandler, TaxReturnFormulaFailedHandler } from '@dec/shared';
import { type FormulaFailed } from 'app/modules/FormDefinition/models/definition.types';
import { useFormLogRulesStore } from 'app/modules/FormDefinition/stores/useFormLogRulesStore';

import { type CellChanged } from '../../models/types';
import { useGetFormConnection } from '../../services/signalr.hooks';

export const HandlerCellChanged = ({ onChange }: { onChange?: (data: any) => void }) => {
  const connection = useGetFormConnection();
  const addLogRule = useFormLogRulesStore((state) => state.addLogRule);

  return (
    <TaxReturnCellChangedHandler<CellChanged>
      connection={connection}
      addLogRule={addLogRule}
      onChange={onChange}
    />
  );
};

export const HandlerFormulaFailed = () => {
  const connection = useGetFormConnection();
  const addLogRule = useFormLogRulesStore((state) => state.addLogRule);

  return (
    <TaxReturnFormulaFailedHandler<FormulaFailed> connection={connection} addLogRule={addLogRule} />
  );
};
